import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
  throw new Error('REACT_APP_API_URL environment variable is required. Please set it in your environment variables.');
}

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true  // Enable credentials
});

// Add request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    // Token already includes 'Bearer' prefix
    config.headers.Authorization = token;
  }
  return config;
});

export const submitApplication = async (eventId, applicationData, selectedTierId = null, file = null, selectedCheckboxes = null, questionAnswers = null) => {
  try {
    const token = localStorage.getItem('token');
    
    // If we have a file, tier, checkboxes, or question answers, use FormData
    if (file || selectedTierId !== null || (selectedCheckboxes && selectedCheckboxes.length > 0) || (questionAnswers && Object.keys(questionAnswers).length > 0)) {
      const formData = new FormData();
      
      // Add application data as JSON string
      if (applicationData) {
        formData.append('application_data', JSON.stringify(applicationData));
      }
      
      // Add tier selection if provided
      if (selectedTierId !== null) {
        formData.append('selected_tier_id', selectedTierId);
      }
      
      // Add checkboxes if provided
      if (selectedCheckboxes && selectedCheckboxes.length > 0) {
        formData.append('selected_checkboxes', JSON.stringify(selectedCheckboxes));
      }
      
      // Add question answers if provided
      if (questionAnswers && Object.keys(questionAnswers).length > 0) {
        formData.append('question_answers', JSON.stringify(questionAnswers));
      }
      
      // Add file if provided
      if (file) {
        formData.append('attachment', file);
      }
      
      const response = await axios.post(
        `${API_URL}/events/${eventId}/applications/`,
        formData,
        {
          headers: {
            'Authorization': token,
            'Content-Type': 'multipart/form-data',
          },
          withCredentials: true,
        }
      );
      return response.data;
    } else {
      // Use JSON for backward compatibility
      const response = await api.post(`/events/${eventId}/applications`, applicationData);
      return response.data;
    }
  } catch (error) {
    console.error('Error submitting application:', error);
    throw error;
  }
};

export const getApplications = async () => {
  const response = await api.get('/applications');
  return response.data;
};

export const getApplicationById = async (id) => {
  const response = await api.get(`/applications/${id}`);
  return response.data;
};

export const updateApplicationStatus = async ({ applicationId, status }) => {
  const token = localStorage.getItem('token');
  const response = await axios.patch(
    `${API_URL}/applications/${applicationId}/status`,
    { status },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const getEventApplications = async (eventId) => {
  const token = localStorage.getItem('token');
  const response = await axios.get(`${API_URL}/events/${eventId}/applications`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
}; 